<fuse-alert [type]="data.type" [appearance]="data.appearance" [showIcon]="data.showIcon">
  <span fuseAlertTitle>{{ data.title }}</span>
  {{ data.message}}
</fuse-alert>